<template>
  <div>Exam notification will come here</div>
</template>
